import { StepData } from '@/lib/Steppers/types';

export type AudienceStepId = 'nameAndMetadata' | 'expression' | 'sync' | 'confirmation';

export const AUDIENCE_EDIT_STEPS: ReadonlyArray<StepData<AudienceStepId>> = [
  {
    id: 'nameAndMetadata',
    title: 'audience_edit:steps.audience',
  },
  {
    id: 'expression',
    title: 'audience_edit:steps.rules',
  },
  {
    id: 'sync',
    title: 'audience_edit:steps.sync',
  },
  {
    id: 'confirmation',
    title: 'audience_edit:steps.confirmation',
  },
] as const;

export const PROPERTY_OPERATIONS_LABEL_MAPPER = {
  GTE: 'rules.greater_than_equal',
  GT: 'rules.greater_than',
  LT: 'rules.less_than',
  LTE: 'rules.less_than_equal',
  EQUALS: 'rules.exactly',
  NOT_NULL: 'rules.not_null',
  NULL: 'rules.null',
  CONTAINS: 'rules.contains',
  NOT_EQUALS: 'rules.not_equals',
  AVG: 'rules.aggregation.avg',
  MAX: 'rules.aggregation.max',
  MIN: 'rules.aggregation.min',
  SUM: 'rules.aggregation.sum',
  COUNT: 'rules.aggregation.count',
  NONE: 'rules.aggregation.none',
} as const;
